














































import { Vue, Component, Prop } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import moment from 'moment-mini'
import { MemberMap } from '@/types/newPersion'
import { customerId } from '@/views/newPension/utils'
import { memberSave } from '@/api/newPersion'

import {
  genderList,
  memberList as memberBodyList,
} from '@/views/newPension/utils/default'

import TsTable from '@/components/TsTable/TsTable.vue' // @ is an alias to /src
import FormItem from '@/components/formItem/index.vue'
import DoalogSlot from '@/components/dialog/doalogSlot.vue'

@Component({
  components: { FormItem, DoalogSlot, TsTable },
})
export default class PersionDialog extends Vue {
  @Prop() familyInfo!: MemberMap | null
  memberBodyList = memberBodyList;
  genderList = genderList;
  defaultKey = {
    label: 'name',
    value: 'type',
  };

  cloneForm: MemberMap = {
    memberName: '', // 昵称
    gender: '', // 性别
    birthDate: '', // 生日
    memberType: '', // 与本人关系
  }

  form = cloneDeep(this.cloneForm)

  created () {
    if (this.familyInfo) {
      this.form = this.familyInfo
    }
  }

  private async submit () {
    if (!this.$validator(this.$refs.form)) {
      const _form = cloneDeep(this.form)
      _form.birthDate = moment(this.form.birthDate).format('YYYY-MM') + '-01'
      const res = await memberSave({ ..._form, customerId })
      if (res?.data) {
        this.$message({
          type: 'success',
          message: '设置成功'
        })
        return true
      }
      return false
    }
    return false
  }
}
